import * as React from 'react';

var _path, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgNoble = function SvgNoble(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M60 0C26.863 0 0 26.863 0 60s26.863 60 60 60 60-26.863 60-60S93.137 0 60 0"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_1593_4113)",
        d: "M85.987 66.997a18.9 18.9 0 0 1-1.44 7.27 18.9 18.9 0 0 1-4.115 6.161 18.9 18.9 0 0 1-6.164 4.116 18.9 18.9 0 0 1-7.253 1.443h-.092a19 19 0 0 1-11.204-3.68 19.09 19.09 0 0 1-7.708-15.303v-14a4.97 4.97 0 0 1 1.464-3.532 4.984 4.984 0 0 1 7.056.004 4.98 4.98 0 0 1 1.464 3.526v13.997a8.94 8.94 0 0 0 2.646 6.365 8.95 8.95 0 0 0 4.607 2.453 9 9 0 0 0 5.197-.511 8.98 8.98 0 0 0 4.038-3.313A8.96 8.96 0 0 0 76.009 67V39.004a4.97 4.97 0 0 1 1.462-3.529 4.99 4.99 0 0 1 8.516 3.53zM46.64 46.633a8.96 8.96 0 0 0-2.641 6.369v27.993a4.96 4.96 0 0 1-1.463 3.53c-1.885 1.887-5.174 1.887-7.06 0a4.97 4.97 0 0 1-1.462-3.53V53.003a19 19 0 0 1 4.616-12.398 19 19 0 0 1 28.41-.385l.029-.033.026.1a19 19 0 0 1 4.084 7.209l.077.256c.496 1.708.747 3.474.749 5.25v13.995a5 5 0 0 1-3.08 4.61 5 5 0 0 1-1.856.37v.01c-.025 0-.048-.008-.073-.008-.317 0-.637-.021-.954-.085a5 5 0 0 1-.539-.148v-.024c-.12-.04-.243-.059-.36-.106a5 5 0 0 1-3.08-4.612V54.33h-.003V53a9.01 9.01 0 0 0-5.597-8.33 8.7 8.7 0 0 0-3.457-.675 8.96 8.96 0 0 0-6.366 2.638m40.72-13.99a8.96 8.96 0 0 0-6.362-2.64h-.004a8.96 8.96 0 0 0-6.356 2.647 8.96 8.96 0 0 0-2.633 6.356v1.011a23.03 23.03 0 0 0-26.67-8.703 22.9 22.9 0 0 0-11.11 8.41A22.9 22.9 0 0 0 30 53.002v27.993c0 2.405.937 4.666 2.638 6.367A8.94 8.94 0 0 0 39.005 90a8.95 8.95 0 0 0 6.367-2.638 8.95 8.95 0 0 0 2.639-6.367V79.99a23.04 23.04 0 0 0 26.66 8.696 22.9 22.9 0 0 0 11.106-8.41A22.9 22.9 0 0 0 90 67.007V39.002a8.96 8.96 0 0 0-2.642-6.362z"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_1593_4113",
        x1: 27.353,
        x2: 89.655,
        y1: 89.557,
        y2: 22.812,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.05,
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.38,
        stopColor: "#A7B3FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#74A4FF"
    })))));
};

export { SvgNoble as ReactComponent };
//# sourceMappingURL=NOBLE.svg.es.js.map
